// extracted by mini-css-extract-plugin
export var csatScore = "_ni-5";
export var header = "_ni-1";
export var panelWrapper = "_ni-2";
export var postPreview = "_ni-3";
export var rightContent = "_ni-0";
export var wrappingText = "_ni-4";